module.exports = __webpack_public_path__ + "img/normal_marker.357a192d.svg";